var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-collapse',{attrs:{"accordion":"","type":"margin"}},_vm._l((_vm.faqs),function(faq,index){return _c('app-collapse-item',{key:index,attrs:{"title":faq.question}},[_vm._v(" "+_vm._s(faq.answer)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }